import { styled } from '@goodfynd/theme';
import { Button } from '@goodfynd/ui';

export const StyledContainer = styled('aside', {
  maxWidth: '100%',
  paddingBottom: 244,
  position: 'relative',
  width: 400,
});

export const StyledIconButton = styled(Button, {
  minWidth: 'auto',
  padding: '15px 12px 17px !important',
});

export const StyledTitleContainer = styled('div', {
  padding: '30px 24px',
});

export const StyledTotalsContainer = styled('section', {
  backgroundColor: 'var(--BackgroundBase1)',
  bottom: 0,
  boxShadow:
    '0px -4px 20px rgba(0, 0, 0, 0.05), 0px -2px 12px rgba(0, 0, 0, 0.05)',
  maxWidth: '95%',
  position: 'fixed',
  right: 0,
  width: 400,
});
